import { EmptyState } from "@design-system/EmptyState/EmptyState";

interface Props {
    isError: boolean;
    hasActiveFilters: boolean;
    onClearFilters: () => void;
    onGoToTemplates: () => void;
}

export const ServiceTemplateSchedulesEmptyState = ({
    isError,
    hasActiveFilters,
    onClearFilters,
    onGoToTemplates,
}: Props) => {
    if (isError) {
        return (
            <EmptyState
                header="Failed to load schedules"
                body="Something went wrong while loading schedules. Please try again."
                ctaText={undefined}
            />
        );
    }
    if (hasActiveFilters) {
        return (
            <EmptyState
                header="No schedules found"
                body="No schedules match your search or filters."
                ctaText="Clear filters"
                action={onClearFilters}
            />
        );
    }
    return (
        <EmptyState
            header="No schedules yet"
            body="Schedules are created by applying a template as recurring. Pick a template to set one up."
            ctaText="Go to templates"
            action={onGoToTemplates}
        />
    );
};
